(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moso-pdp-social-proof"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moso-review-rail')) {
    customElements.define(
      'moso-review-rail',
      class MosoReviewRail extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-review-track]');
          this.previousButton = this.querySelector('[data-review-prev]');
          this.nextButton = this.querySelector('[data-review-next]');

          if (!this.track) return;

          this.previousButton?.addEventListener('click', () => this.move(-1));
          this.nextButton?.addEventListener('click', () => this.move(1));
        }

        move(direction) {
          const card = this.track.querySelector('.moso-pdp-review-card');
          if (!card) return;

          const styles = window.getComputedStyle(this.track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap || 0);
          const distance = card.getBoundingClientRect().width + gap;

          this.track.scrollBy({
            left: direction * distance,
            behavior: 'smooth',
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
